import index from "./requestLeave.vue";
import detail from "./requestLeaveDetail.vue";

let routesRequestMuat = [
    {
      path: '',
      meta: {
        title: "Chain System",
      },
      name: "requestLeave",
      component: index
    },
    {
      path: 'detail/:id',
      meta: {
        title: "Chain System",
      },
      name: "requestLeaveDetail",
      component: detail
    },
    
   
]

export default routesRequestMuat
  